import { combineReducers } from 'redux'
import { InsurancesFetch } from './insurances/types'

import campaignsReducer from './campaigns/reducer'
import clientReducer from './client/reducer'
import clientPropertiesReducer from './clientProperties/reducer'
import clientsReducer from './clients/reducer'
import commentsReducer from './comments/reducer'
import communicationsReducer from './communications/reducer'
import companiesReducer from './companies/reducer'
import companyReducer from './company/reducer'
import configReducer from './config/reducer'
import discountsReducer from './discounts/reducer'
import employeeReducer from './employee/reducer'
import employeesReducer from './employees/reducer'
import estimateReducer from './estimate/reducer'
import estimateItemsReducer from './estimateItems/reducer'
import estimatesReducer from './estimates/reducer'
import estimatesByCategoryReducer from './estimatesByCategory/reducer'
import filesReducer from './files/reducer'
import filtersReducer from './filters/reducer'
import groupedOrdersReducer from './groupedOrders/reducer'
import historyReducer from './history/reducer'
import homemartReducer from './homemart/reducer'
import inspectionCompaniesReducer from './inspectionCompanies/reducer'
import inspectionCompanyReducer from './inspectionCompany/reducer'
import inspectionReportsReducer from './inspectionReports/reducer'
import inspectorsReducer from './inspectors/reducer'
import insurancesReducer from './insurances/reducer'
import invitationsReducer from './invitations/reducer'
import invoiceReducer from './invoice/reducer'
import itemsReducer from './items/reducer'
import jobReducer from './job/reducer'
import jobsReducer from './jobs/reducer'
import licensesReducer from './licenses/reducer'
import matchReducer from './match/reducer'
import matchesReducer from './matches/reducer'
import materialReducer from './material/reducer'
import materialInvoicesReducer from './materialInvoice/reducer'
import materialsReducer from './materials/reducer'
import navbarReducer from './navBar/reducer'
import newEstimateReducer from './newEstimate/reducer'
import notesReducer from './notes/reducer'
import notificationsReducer from './notifications/reducer'
import orderReducer from './order/reducer'
import ordersReducer from './orders/reducer'
import paymentsReducer from './payments/reducer'
import pcViewReducer from './pc-view/reducer'
import priceModelsReducer from './priceModels/reducer'
import promoCodesReducer from './promoCodes/reducer'
import repairItemReducer from './repairItem/reducer'
import repairListReducer from './repairList/reducer'
import searchesReducer from './searches/reducer'
import siteVisitReducer from './siteVisit/reducer'
import siteVisitsReducer from './siteVisits/reducer'
import subscriptionReducer from './subscription/reducer'
import subscriptionsReducer from './subscriptions/reducer'
import territoriesReducer from './territories/reducer'
import territoryReducer from './territory/reducer'
import tradeTypesReducer from './tradeTypes/reducer'
import vendorReducer from './vendor/reducer'
import vendorsReducer from './vendors/reducer'
import widgetReducer from './widget/reducer'
import widgetsReducer from './widgets/reducer'
import workOrdersReducer from './work-orders/reducer'
import workflowsReducer from './workflows/reducer'

import { ClientType } from './client/types'
import { ClientPropertiesType } from './clientProperties/types'
import { ClientsType } from './clients/types'
import { CommentsType } from './comments/types'
import { CommunicationsType } from './communications/types'
import { CompaniesType } from './companies/types'
import { CompanyType } from './company/types'
import { ConfigType } from './config/types'
import { DiscountsType } from './discounts/types'
import { EmployeeType } from './employee/types'
import { EmployeesType } from './employees/types'
import { EstimateType } from './estimate/types'
import { EstimateItemsType } from './estimateItems/types'
import { EstimatesType } from './estimates/types'
import { EstimatesByCategoryType } from './estimatesByCategory/types'
import estimateSelectionReducer from './estimateSelection/reducer'
import { EstimateSelectionState } from './estimateSelection/types'
import { FilesState } from './files/reducer'
import { FiltersType } from './filters/types'
import { GroupedOrdersType } from './groupedOrders/types'
import { HistoryType } from './history/types'
import { HomemartType } from './homemart/types'
import { InspectionCompaniesType } from './inspectionCompanies/types'
import { InspectionCompanyType } from './inspectionCompany/types'
import { InspectionReportsType } from './inspectionReports/types'
import { Invitation } from './invitations/types'
import { Invoice } from './invoice/types'
import { ItemsType } from './items/types'
import { JobType } from './job/types'
import { JobsType } from './jobs/types'
import { LicensesType } from './licenses/types'
import { MatchType } from './match/types'
import { MatchesType } from './matches/types'
import { MaterialType } from './material/types'
import { MaterialInvoices } from './materialInvoice/types'
import { MaterialsType } from './materials/types'
import { NewEstimateType } from './newEstimate/types'
import { Notes } from './notes/types'
import { NotificationType } from './notifications/types'
import { Order } from './order/types'
import { OrdersType } from './orders/types'
import { PaymentsType } from './payments/types'
import { PCViewType } from './pc-view/types'
import { PriceModelType } from './priceModels/types'
import { PromoCodesType } from './promoCodes/types'
import { RepairItemType } from './repairItem/types'
import { RepairListType } from './repairList/types'
import { Searches } from './searches/types'
import { SiteVisitType } from './siteVisit/types'
import { SiteVisitsType } from './siteVisits/types'
import { SubscriptionType } from './subscription/types'
import { SubscriptionsType } from './subscriptions/types'
import { TerritoriesType } from './territories/types'
import { TerritoryType } from './territory/types'
import { Trades } from './tradeTypes/types'
import { InspectorCompany, Widget } from './types'
import { VendorType } from './vendor/types'
import { VendorsType } from './vendors/types'
import { WidgetsType } from './widgets/types'
import { WorkOrdersType } from './work-orders/types'
import { WorkflowsType } from './workflows/types'

export interface State {
  client: ClientType
  clientProperties: ClientPropertiesType
  clients: ClientsType
  config: ConfigType
  employee: EmployeeType
  employees: EmployeesType
  oldemployees: EmployeesType
  order: Order
  orders: OrdersType
  vendor: VendorType
  vendors: VendorsType
  searches: Searches
  siteVisit: SiteVisitType
  siteVisits: SiteVisitsType
  promoCodes: PromoCodesType
  territories: TerritoriesType
  territory: TerritoryType
  job: JobType
  jobs: JobsType
  licenses: LicensesType
  companies: CompaniesType
  company: CompanyType
  items: ItemsType
  workflows: WorkflowsType
  notifications: NotificationType
  comments: CommentsType
  notes: Notes
  invoice: Invoice
  payments: PaymentsType
  tradeTypes: Trades
  communications: CommunicationsType
  materialInvoices: MaterialInvoices
  history: HistoryType
  priceModel: PriceModelType
  estimates: EstimatesType
  estimatesByCategory: EstimatesByCategoryType
  estimate: EstimateType
  filters: FiltersType
  invitations: Invitation
  subscriptions: SubscriptionsType
  subscription: SubscriptionType
  insurances: InsurancesFetch
  estimateItems: EstimateItemsType
  newEstimate: NewEstimateType
  widgets: WidgetsType
  widget: Widget
  matches: MatchesType
  match: MatchType
  repairList: RepairListType
  repairItem: RepairItemType
  material: MaterialType
  materials: MaterialsType
  groupedOrders: GroupedOrdersType
  homemart: HomemartType
  discounts: DiscountsType
  workOrders: WorkOrdersType
  pcView: PCViewType
  inspectionCompanies: InspectionCompaniesType
  inspectionCompany: InspectionCompanyType
  inspectors: InspectorCompany
  estimateSelection: EstimateSelectionState
  inspectionReports: InspectionReportsType
  files: FilesState
}

const rootReducer = combineReducers({
  client: clientReducer,
  clientProperties: clientPropertiesReducer,
  clients: clientsReducer,
  config: configReducer,
  employee: employeeReducer,
  employees: employeesReducer,
  oldemployees: employeesReducer,
  order: orderReducer,
  orders: ordersReducer,
  vendor: vendorReducer,
  vendors: vendorsReducer,
  searches: searchesReducer,
  siteVisit: siteVisitReducer,
  siteVisits: siteVisitsReducer,
  promoCodes: promoCodesReducer,
  territories: territoriesReducer,
  territory: territoryReducer,
  job: jobReducer,
  jobs: jobsReducer,
  licenses: licensesReducer,
  companies: companiesReducer,
  company: companyReducer,
  items: itemsReducer,
  workflows: workflowsReducer,
  notifications: notificationsReducer,
  comments: commentsReducer,
  notes: notesReducer,
  invoice: invoiceReducer,
  payments: paymentsReducer,
  tradeTypes: tradeTypesReducer,
  communications: communicationsReducer,
  navbar: navbarReducer,
  materialInvoices: materialInvoicesReducer,
  history: historyReducer,
  priceModel: priceModelsReducer,
  estimates: estimatesReducer,
  estimatesByCategory: estimatesByCategoryReducer,
  estimate: estimateReducer,
  invitations: invitationsReducer,
  filters: filtersReducer,
  subscriptions: subscriptionsReducer,
  subscription: subscriptionReducer,
  insurances: insurancesReducer,
  estimateItems: estimateItemsReducer,
  newEstimate: newEstimateReducer,
  widgets: widgetsReducer,
  widget: widgetReducer,
  matches: matchesReducer,
  match: matchReducer,
  repairList: repairListReducer,
  repairItem: repairItemReducer,
  material: materialReducer,
  materials: materialsReducer,
  groupedOrders: groupedOrdersReducer,
  homemart: homemartReducer,
  discounts: discountsReducer,
  campaigns: campaignsReducer,
  workOrders: workOrdersReducer,
  pcView: pcViewReducer,
  inspectionCompanies: inspectionCompaniesReducer,
  inspectionCompany: inspectionCompanyReducer,
  inspectors: inspectorsReducer,
  estimateSelection: estimateSelectionReducer,
  inspectionReports: inspectionReportsReducer,
  files: filesReducer,
})

export default rootReducer
